import React from 'react'
import { AvatarStyle } from './styles'
import defaultImage from '../../assets/images/default-image.png'

export interface AvatarProps {
  height?: number
  width?: number
  borderRadius?: number
  source?: string | File
  loading?: boolean
  onPress?: any
}

const Avatar: React.FunctionComponent<AvatarProps> = ({
  width = 50,
  height = 50,
  onPress,
  borderRadius = 100,
  loading,
  source,
}) => {
  return (
    <AvatarStyle.Container
      width={width}
      borderRadius={borderRadius}
      height={height}
      src={typeof source === 'string' ? source : defaultImage}
      onClick={onPress}
    />
  )
}

export default Avatar
